import { render, staticRenderFns } from "./LogPointer.vue?vue&type=template&id=57f1b496&scoped=true&"
import script from "./LogPointer.vue?vue&type=script&lang=js&"
export * from "./LogPointer.vue?vue&type=script&lang=js&"
import style0 from "./LogPointer.vue?vue&type=style&index=0&id=57f1b496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f1b496",
  null
  
)

export default component.exports